export default __webpack_public_path__ + "static/media/ger-flag.f484b2a3.svg";